import { Trans, useTranslation } from 'react-i18next';
import { setComma } from 'utils/common';

export default function MoaInfoText({
  currentPrice,
  moa,
}: {
  currentPrice: number;
  moa: number;
}) {
  const { t } = useTranslation('store');
  return (
    <div className="flex justify-center text-[12px] mb-[10px]">
      {currentPrice < moa ? (
        <div className="text-center">
          <p className="text-primary-700">
            {t('additional_amount_for_delivery', {
              amount: setComma(moa - currentPrice),
            })}
          </p>
          <p className="text-[#6B7280]">
            {t('minimum_order_amount_label')} {setComma(moa)}Won
          </p>
        </div>
      ) : (
        <p className="text-primary-700">
          {t('store:delivery_is_available_notice')}
        </p>
      )}
    </div>
  );
}
